import { Component, OnInit } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { UserAttributionsEnum } from '@app/@core/constants/user-credentials.constants';
import { ResponseDialogComponent } from '@app/@shared/dialogs/response/response-dialog.component';
import { AuthenticationService, CredentialsService } from '@app/login';
import { TranslateService } from '@ngx-translate/core';
import { DocumentInterestDTO } from '../model/training.model';
import { TrainingStore } from '../services/training.store';

@Component({
  selector: 'app-documentation',
  templateUrl: './documentation.component.html',
  styleUrls: ['./documentation.component.scss'],
})
export class DocumentationComponent implements OnInit {
  data: DocumentInterestDTO[] = [];
  isConsumption: boolean = false;
  isAuto: boolean = false;

  constructor(
    private trainingStore: TrainingStore,
    private credentials: CredentialsService,
    private dialog: MatDialog,
    private translateService: TranslateService,
    private authenticationService: AuthenticationService
  ) {}

  ngOnInit(): void {
    this.isAuto = this.credentials.isDivisionAutos();
    this.isConsumption =
      this.credentials.isDivisionConsumption() &&
      !this.credentials.credentials.attribIds.includes(UserAttributionsEnum.ATTR_CAPTAIN_BUY_MG) &&
      !this.credentials.credentials.attribIds.includes(UserAttributionsEnum.ATTR_CAPTAIN_NO_BUY_MG) &&
      !this.credentials.credentials.attribIds.includes(UserAttributionsEnum.ATTR_ALTA_BP);

    this.getDocuments();

    this.translateService.onLangChange.subscribe(() => {
      this.getDocuments();
    });
  }

  private getDocumentationAutos() {
    const documentationAuto = this.trainingStore.getPdfsAutos();
    this.data.push(...documentationAuto);
  }

  private getDocumentationConsumption() {
    const documentationConsumption = this.trainingStore.getPdfsConsumption();
    this.data.push(...documentationConsumption);
  }

  private getDocumentationStatic() {
    const documentationConsumption = this.trainingStore.getPdfsStaticComunications();
    this.data.push(...documentationConsumption);
    console.warn(this.data);
  }

  private getDocumentationRequestCredit() {
    const documentationConsumption = this.trainingStore.getPdfsRequestCredit();
    this.data.push(...documentationConsumption);
  }

  private getDocuments() {
    return this.trainingStore
      .getDocumentation()
      .then(
        (result) => {
          if (result) {
            this.data = result.map<DocumentInterestDTO>((doc) => {
              const link = doc.link.split('/');
              return {
                id: doc.id,
                name: this.translateService.instant(doc.comunicationName.replace('.pdf', '')),
                size: '',
                filename: link[link.length - 1],
                jasper: doc.jasper,
                pdf: doc.pdf,
              };
            });
          }
        },
        (error) => console.error(error)
      )
      .finally(() => {
        this.getDocumentationStatic();
        if (this.authenticationService.permissionAction(UserAttributionsEnum.ATTR_DOCUMENT_INTEREST)) {
          this.getDocumentationRequestCredit();
          if (this.isConsumption) {
            this.getDocumentationConsumption();
          } else if (this.isAuto) {
            this.getDocumentationAutos();
          } else {
            if (this.data.length === 0) {
              this.openErrorResponseDialog(this.translateService.instant('formationDocumentation.error.noDocuments'));
            }
          }
        }
      });
  }

  private openErrorResponseDialog(text: string) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.data = {
      text: text,
      icon: undefined,
      title: undefined,
      buttonCancel: false,
      noRedirect: true,
    };
    this.dialog.open(ResponseDialogComponent, dialogConfig);
  }
}
